import api from '@/api';
import { findClosestValue } from '@/components/WellLoggingOperations/utils';

const initialState = {
    /*
        Данные по смещениям для скважин.

        {
            [wellId]: {
                [versionId]: [offsets data]
            },
            ...
        }

        Данные группируются по версиям в процессе нормализации.
    */
    offsetsByWell: {},
};

export const offsetWellModel = {
    name: 'offsetWell',
    state: initialState,
    reducers: {
        setOffsetWell(state, payload) {
            const { offsetsByWell } = state;
            const { wellId, data } = payload;

            const updatedOffsetsByWell = { ...offsetsByWell, [wellId]: data };

            return { ...state, offsetsByWell: updatedOffsetsByWell };
        },
    },
    effects: {
        async getOffsetsByWell(wellId, rootState) {
            const { offsetsByWell } = rootState.offsetWell;
            const { absDepthByWellId } = rootState.inclinometry;

            /*
                По мере загрузки данных, проверяем, были ли уже загружены смещения по указанной скважине.
                Если были - пропускаем шаг с загрузкой.
            */
            if (wellId in offsetsByWell) return;

            try {
                const result = await api.carottage.fetchOffsets({ wellId: [wellId] });

                const payload = { wellId };

                if (wellId in result.offsetsByWell) {
                    const dataWithRel = addRel(result.offsetsByWell[wellId], Object.entries(absDepthByWellId[wellId]));
                    const normalizeData = normalize(dataWithRel);

                    payload.data = normalizeData;
                } else {
                    payload.data = {};
                }

                this.setOffsetWell(payload);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.log('error::fetch offsets for well', error);
            }
        },
    },
};

function normalize(data) {
    const result = {};

    for (const item of Object.values(data)) {
        const { versionId } = item;

        if (result[versionId]) {
            result[versionId].push(item);
        } else {
            result[versionId] = [item];
        }
    }

    return result;
}

function addRel(array, abs) {
    return array.map(item => {
        const roof = findClosestValue(abs, item.absRoof, x => x?.[1] ?? 0);
        const bottom = findClosestValue(abs, item.absBottom, x => x?.[1] ?? 0);

        return {
            ...item,
            roof: Number(roof?.[0] ?? 0),
            bottom: Number(bottom?.[0] ?? 0),
        };
    });
}
